import { MdArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

function TitleBar(props) {
  const navigate = useNavigate()

  const goBack = () => {
    if (props?.path) {
      return navigate(props?.path, { state: props?.state })
    }

    navigate(-1)
  }

  return (<Wrapper>
    <BackButton size={25} onClick={goBack} />
    <Title>{props?.title || props?.children || ''}</Title>
  </Wrapper>)
}

export default TitleBar

// App không cấu hình styled-components ThemeProvider → `theme` luôn
// undefined. Fallback an toàn để các page legacy (NotFoundPage,
// DrivingTestPage) còn dùng TitleBar không crash. Khi sau này nối
// ThemeProvider, các nhánh `theme?.color?...` tự nhận giá trị thật.
const Wrapper = styled.div`
  background-color: ${({ theme }) => {
    const h = theme?.color?.header?.background;
    return theme?.isDesktop ? (h?.desktop || '#ffffff') : (h?.mobile || '#ffffff');
  }};
  width: 100%;
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
`

const BackButton = styled(MdArrowBack)`
  color: ${({ theme }) => {
    const b = theme?.color?.header?.button;
    return theme?.isDesktop ? (b?.desktop || '#334155') : (b?.mobile || '#334155');
  }};
  cursor: pointer;
  position: absolute;
  margin: 0 1rem;
`

const Title = styled.p`
  color: ${({ theme }) => theme?.color?.header?.text?.mobile || '#0f172a'};
  font-weight: bold;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
`